import { Guia } from "./Guia";
import {
  ParametrosCaneta,
  PreferenciasUsuario,
  ProvaDatasource,
} from "./UserData";
import { Marcacao } from "./Marcacao";
import { EstatisticasLeitura } from "./usuario/EstatisticasLeitura";
import { EntitiesHelper } from "../helpers/entities.helper";
import { Apontamento } from "./Apontamento";
import { EnumPerfilUsuario } from "../enums/EnumPerfilUsuario";

export class UserdataDTO {
  public id: string;
  public email: string;
  public nome: string;
  public sobrenome: string;
  public foto: string;

  public palavrasMinuto: number;
  public perfilUsuario: EnumPerfilUsuario;

  public parametrosCaneta: ParametrosCaneta;

  public guias: Guia[];
  public marcacoesProva: Marcacao[];
  public apontamentos: Apontamento[];
  public preferencias: PreferenciasUsuario;
  public provaDatasource: ProvaDatasource;
  public estatisticasLeitura: EstatisticasLeitura[];

  fontSize: number;

  // Campos de controle
  public authToken: string;
  dataUltimaAlteracao: Date;
}

export class BaseObj {
  public id: string;
  public dataHoraModificacao: Date;
  public removido: boolean;

  constructor() {
    this.id = EntitiesHelper.generateGuid();
    this.dataHoraModificacao = new Date();
    this.removido = false;
  }
}
